var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.469,
    height: 26.113,
    viewBox: "0 0 23.469 26.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e76e13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6aa4a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_6",
    transform: "translate(-2.87 -1.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M22.376,1.672H6.833A3.975,3.975,0,0,0,2.87,5.635v6.612a3.963,3.963,0,0,0,3.963,3.963h3.462a1.274,1.274,0,0,1,1.093.619l1.1,1.831a2.047,2.047,0,0,0,3.511,0l1.1-1.831a1.274,1.274,0,0,1,1.093-.619h4.19a3.963,3.963,0,0,0,3.963-3.963V5.635a3.963,3.963,0,0,0-3.963-3.963Zm-4.7,8.207h-6.14a1.1,1.1,0,1,1,0-2.208h6.14a1.1,1.1,0,0,1,0,2.208Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M23.407,19.862l-1.435-.207a.764.764,0,0,1-.576-.418l-.639-1.3a1.14,1.14,0,0,0-1.976,0l-.649,1.3a.764.764,0,0,1-.574.414l-1.437.208a1.11,1.11,0,0,0-.607,1.888l1.038,1.012a.764.764,0,0,1,.22.675l-.242,1.427a1.085,1.085,0,0,0,.441,1.082,1.1,1.1,0,0,0,1.159.077l1.279-.674a.763.763,0,0,1,.71,0l1.289.675a1.082,1.082,0,0,0,1.159-.077,1.106,1.106,0,0,0,.441-1.082l-.25-1.424a.764.764,0,0,1,.219-.679l1.036-1.01a1.1,1.1,0,0,0,.287-1.137A1.119,1.119,0,0,0,23.407,19.862Z",
    transform: "translate(1.279 1.631)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M11.737,19.866,10.3,19.659a.764.764,0,0,1-.576-.418l-.639-1.3a1.107,1.107,0,0,0-1.987,0l-.639,1.3a.764.764,0,0,1-.576.418l-1.435.207a1.1,1.1,0,0,0-.607,1.888l1.036,1.01a.764.764,0,0,1,.219.679l-.25,1.424a1.1,1.1,0,0,0,1.612,1.159l1.278-.673a.764.764,0,0,1,.712,0l1.278.673a1.1,1.1,0,0,0,1.612-1.159l-.25-1.424a.764.764,0,0,1,.219-.679l1.036-1.01a1.1,1.1,0,0,0-.607-1.888Z",
    transform: "translate(0.066 1.627)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.6fa3bf597edb26f3eed820e1dd77f31a.svg";
export { ForwardRef as ReactComponent };